import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8815d8d2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8815d8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815d8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8815d8d2')) {
      api.createRecord('8815d8d2', component.options)
    } else {
      api.reload('8815d8d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8815d8d2&scoped=true&", function () {
      api.rerender('8815d8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/aliAppLink/index.vue"
export default component.exports